import React from 'react'
import classNames from 'classnames'
import { formatLaunchDate } from '@helpers/products/comingSoon'
import styles from './styles.module.scss'

type ComingSoonInfoProps = {
  // YYYY-MM-DD, from getComingSoonLaunchDate.
  launchDate: string
  classes?: string
}

// The launch line above the CTA of a colourway that hasn't landed yet, in
// the same place and style as the made to order dispatch line.
function ComingSoonInfo({ launchDate, classes }: ComingSoonInfoProps) {
  return (
    <p className={classNames(styles.comingSoonInfo, classes)}>
      <strong className={styles.comingSoonInfo__title}>Coming soon:</strong>{' '}
      Arrives {formatLaunchDate(launchDate)}
    </p>
  )
}

export default ComingSoonInfo
